import { css } from '@emotion/react';

import { flex } from 'src/styles/utils';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';

import { colors } from '../../../../styles/colors';
import {
  ZeeFontBold,
  ZeeFontRegular,
  getInitialLoadIcons
} from '../../../../styles/font';
import { MediaBP as MQ } from '../../../../styles/mediaQuery';

export const container = css`
  color: ${colors.PrimaryWhiteColor};
  width: 100%;
  ${MQ.MediaLg} {
    border: none;
  }
`;

export const item = css`
  color: ${colors.PrimaryWhiteColorAlpha50};
  ${ZeeFontRegular(12)};
  padding: 8px 0px;
  margin-left: 2px;
  &:hover {
    color: ${colors.PurpleLight};
  }

  a {
    cursor: pointer;
  }
`;

export const title = css`
  ${ZeeFontBold(12)};
  padding: 16px 16px;
  ${flex('row', 'space-between')};
  width: 100%;
  border-top: 1px solid ${colors.PrimaryWhiteColorAlpha10};
  border-bottom: 1px solid ${colors.PrimaryWhiteColorAlpha10};
  ${MQ.MediaMd} {
    padding: 16px 64px;
  }
  ${MQ.MediaLg} {
    padding: 16px 0px;
    border: none;
  }
`;

export const slideDown = css`
  @keyframes slideDown {
    from {
      max-height: 0px;
    }
    to {
      max-height: 500px;
    }
  }
  @keyframes slideUp {
    from {
      max-height: 500px;
    }
    to {
      max-height: 0px;
    }
  }
  animation-duration: 0.2s;
`;

export const showMoreContent = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.SHOW_MORE)};
  font-size: 22px;
`;

export const rotateArrow = (show: boolean) => css`
  transform: rotate(${show ? 180 : 0}deg);
  transition: transform 0.2s linear;
  ${MQ.MediaLg} {
    display: none;
  }
`;

export const containerMobile = (show: boolean) => css`
  animation-name: ${show ? 'slideDown' : 'slideUp'};
  max-height: ${show ? '500px' : '0px'};
  padding: ${show ? 12 : 0}px 16px;
  ${MQ.MediaMd} {
    padding: 0px 64px;
  }
  ${MQ.MediaLg} {
    padding: 0px;
    max-height: 1000px;
    animation: none;
  }
`;

export const collapsible = css`
  padding: 12px 0px;
  ${MQ.MediaMd} {
    column-count: 2;
    padding: 12px 0px;
  }
  ${MQ.MediaLg} {
    column-count: unset;
  }
`;

export const dots = css`
  position: relative;
  padding-left: 14px;
  &:before {
    background: ${colors.PrimaryWhiteColorAlpha50};
    border-radius: 50%;
    bottom: 0;
    content: '';
    height: 5px;
    left: 0;
    margin: auto;
    position: absolute;
    top: 0;
    width: 5px;
  }
  ${MQ.MediaLg} {
    position: unset;
    padding: 0px;
    &:before {
      display: none;
    }
  }
`;
